/*
 * Copyright (c) 2023 Limpide
 *
 *  Permission is hereby granted, free of charge, to any person obtaining a copy of
 *  this software and associated documentation files (the 'Software'), to deal in
 *  the Software without restriction, including without limitation the rights to
 *  use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 *  the Software, and to permit persons to whom the Software is furnished to do so,
 *  subject to the following conditions:
 *
 *  The above copyright notice and this permission notice shall be included in all
 *  copies or substantial portions of the Software.
 *
 *  THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 *  FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 *  COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 *  IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 *  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import Base from '@scripts/components/base'

export default class Marquer extends Base {
    marquerLayers?: {
        type_page: Array<{ valeur: string; page: string; terme: string }>
        page_category: Array<{ valeur: string; type: string; page: string; terme: string }>
        cta_name: Array<{
            valeur: string
            section: string
            type: string
            urlExterne: string
            page: string
            terme: string
        }>
        site_section: Array<{ valeur: string; section: string }>
    }
    headerClickedCta?: string
    ctaNameType?: Array<string>

    constructor(marquerLayers: {
        type_page: Array<{ valeur: string; page: string; terme: string }>
        page_category: Array<{ valeur: string; type: string; page: string; terme: string }>
        cta_name: Array<{
            valeur: string
            section: string
            type: string
            urlExterne: string
            page: string
            terme: string
        }>
        site_section: Array<{ valeur: string; section: string }>
    }) {
        super()

        this.ctaNameType = [
            'page',
            'terme',
            'logo',
            'urlExterne',
            'banniere',
            'article',
            'partageSocial',
            'jeMinscrisNewsletter',
            'inscriptionNewsletterSucess',
            'personnalisationNewsletter',
            'inscriptionJeuxConcours',
            'ancreFicheConcours'
        ]

        marquerLayers && (this.marquerLayers = window.layerData.data_layer)
    }

    start() {
        this.pageLoaded()
        this.heading_click()
        this.footer_click()
        this.cta_click_accueil()
        this.post_listing()
        this.social_share()
        this.click_newsletter()
        this.consent_checkbox()
    }

    bannerDisplayed(): string {
        const bannerMessage = document.querySelector('.banner-message')
        let returnVal = 'no'

        if (bannerMessage) {
            const isDisplayed = window.getComputedStyle(bannerMessage).display

            if (isDisplayed === 'none') {
                returnVal = 'no'
            } else if (isDisplayed === 'block') {
                returnVal = 'yes'
            }
        } else {
            returnVal = 'no'
        }

        return returnVal
    }

    getTitle() {
        return document.title
    }

    get_env() {
        if (window.layerData.data_env) {
            return window.layerData.data_env
        }
    }

    get_page_link() {
        return window.location.href.replace(window.location.search, '')
    }

    get_post_category() {
        if (window.layerData.post_category.length > 0) {
            return window.layerData.post_category
        } else {
            return false
        }
    }

    isSingle() {
        if (window.layerData.post_isSingle) {
            return window.layerData.post_isSingle
        }
    }

    getLastPart(url: string | null) {
        if (url) {
            const parts = url.split('/')
            parts.pop()

            return parts.at(-1)
        } else {
            return ''
        }
    }

    /**
     *
     * @param {object} data
     * @param {string} [type='page, terme']
     * @param {string | boolean} link
     * @param {string | boolean} taxo
     * @returns {string}
     */
    find_page_type(type: string = 'page', link: string | boolean, taxo: string | boolean) {
        const data = this.marquerLayers?.type_page
        let val: any
        let hasVal: boolean = false
        const $type = type

        data?.forEach(element => {
            if (!hasVal) {
                if ($type === 'page') {
                    if (element.page === link && element.valeur.length !== 0) {
                        val = element.valeur
                        hasVal = true
                    } else {
                        val = null
                    }
                } else if ($type === 'terme') {
                    if (element.terme === taxo && element.valeur.length !== 0) {
                        val = element.valeur
                        hasVal = true
                    } else {
                        val = null
                    }
                }
            }
        })

        return val
    }

    /**
     *
     * @param data
     * @param catType
     * @param catVal
     * @returns
     */
    find_page_category(catType: string, catVal: string | boolean = false) {
        let val: any
        const data = this.marquerLayers?.page_category

        data?.forEach(element => {
            if (element.type === catType) {
                switch (element.type) {
                    case 'page':
                        if (catVal) {
                            if (element.page === catVal && element.valeur.length !== 0) {
                                val = element.valeur
                            }
                        } else {
                            val = null
                        }
                        break

                    case 'terme':
                        if (catVal) {
                            if (element.terme === catVal && element.valeur.length !== 0) {
                                val = element.valeur
                            }
                        } else {
                            val = null
                        }
                        break

                    case 'pageList':
                        val = element.valeur
                        break

                    case 'article':
                        val = element.valeur
                        break
                }
            }
        })

        return val
    }

    /**
     *
     * @param data
     * @param ctaType
     * @param ctaSection
     * @param ctaVal
     * @returns
     */
    find_cta_name(ctaType: string | boolean, ctaSection: string, ctaVal: string | boolean = false) {
        const data = this.marquerLayers?.cta_name
        let val: any

        data?.forEach(element => {
            if (element.type === ctaType) {
                switch (element.type) {
                    case 'page':
                        if (element.section === ctaSection) {
                            if (element.page === ctaVal && element.valeur.length !== 0) {
                                val = element.valeur
                            }
                        }

                        break

                    case 'terme':
                        if (element.section === ctaSection) {
                            if (element.terme === ctaVal && element.valeur.length !== 0) {
                                val = element.valeur
                            }
                        }
                        break

                    case 'logo':
                        if (element.section === ctaSection) {
                            val = element.valeur
                        }
                        break

                    case 'urlExterne':
                        if (element.section === ctaSection) {
                            if (element.urlExterne === ctaVal && element.valeur.length !== 0) {
                                val = element.valeur
                            }
                        }
                        break

                    case 'banniere':
                        if (element.section === ctaSection) {
                            val = element.valeur
                        }
                        break

                    case 'article':
                        if (element.section === ctaSection) {
                            val = element.valeur
                        }
                        break

                    case 'partageSocial':
                        if (element.section === ctaSection) {
                            if (element.urlExterne === ctaVal && element.valeur.length !== 0) {
                                val = element.valeur
                            }
                        }
                        break

                    case 'jeMinscrisNewsletter':
                        val = element.valeur
                        break

                    case 'personnalisationNewsletter':
                        val = element.valeur
                        break

                    case 'inscriptionJeuxConcours':
                        val = element.valeur
                        break

                    case 'ancreFicheConcours':
                        val = element.valeur
                        break
                }
            }
        })

        return val
    }

    find_page(data: Array<{ valeur: string; page: string; terme: string }>, pageLink: string) {
        let val: any
        let hasVal: boolean = false

        data?.forEach(element => {
            if (!hasVal) {
                if (element.page === pageLink && element.valeur.length !== 0) {
                    val = element.valeur
                    hasVal = true
                } else {
                    val = null
                }
            }
        })

        return val
    }

    find_terme(data: Array<{ valeur: string; page: string; terme: string }>, category: string) {
        let val: any
        let hasVal: boolean = false

        data?.forEach(element => {
            if (!hasVal) {
                if (element.terme === category && element.valeur.length !== 0) {
                    val = element.valeur
                    hasVal = true
                } else {
                    val = null
                }
            }
        })

        return val
    }

    find_section(data: Array<{ valeur: string; section: string }>, sectionVal: string) {
        let val: any
        let hasVal: boolean = false

        data?.forEach(element => {
            if (!hasVal) {
                if (element.section === sectionVal && element.valeur.length !== 0) {
                    val = element.valeur
                    hasVal = true
                } else {
                    val = null
                }
            }
        })

        return val
    }

    find_qualifio_cta(type: string) {
        let val: string

        val = ''
        this.marquerLayers?.cta_name.forEach(element => {
            if (element.type === type) {
                val = element.valeur
            }
        })

        return val
    }

    pageLoaded() {
        const pageLink = this.get_page_link()
        let pageType: string = ''
        let pageCategory: string = ''
        let pageCategoryFindTerme: string | null = null
        let pageTypeFindTerme: string | null = null
        const pageCategoryFindPage = this.find_page_category('page', pageLink)
        const pageTypeFindPage = this.find_page_type('page', pageLink, false)

        if (this.get_post_category()) {
            const category = this.get_post_category()

            pageCategoryFindTerme = this.find_page_category('terme', category)
            pageTypeFindTerme = this.find_page_type('terme', false, category)
        }

        if (this.isSingle() && this.get_post_category() !== 'jeux concours') {
            const pageCategoryFindArticle = this.find_page_category('article', false)

            if (pageCategoryFindArticle) {
                pageCategory = pageCategoryFindArticle
            }
        }

        if (pageLink?.indexOf('/categorie/') !== -1) {
            const pageCategoryFindPageList = this.find_page_category('pageList', false)

            if (pageCategoryFindPageList) {
                pageCategory = pageCategoryFindPageList
            }
        }

        if (pageCategoryFindPage) {
            pageCategory = pageCategoryFindPage
        } else if (pageCategoryFindTerme && this.isSingle()) {
            pageCategory = pageCategoryFindTerme
        }

        if (pageTypeFindPage) {
            pageType = pageTypeFindPage
        } else if (pageTypeFindTerme) {
            pageType = pageTypeFindTerme
        }

        window.dataLayer.push({
            event: 'page.display',
            page: this.getTitle(),
            page_chapter1: pageType,
            page_chapter2: pageCategory,
            page_chapter3: this.get_page_link(),
            page_chapter4: this.bannerDisplayed(),
            environment: this.get_env(),
            language: 'fr'
        })
    }

    heading_click() {
        document
            .querySelector('.banner-top')
            ?.querySelectorAll('a')
            .forEach(button => {
                button.addEventListener('click', () => {
                    let pageType: string = ''
                    let ctaName: string = ''
                    let ctaNameFindTerme: string | null = null
                    let pageTypeFindTerme: string | null = null
                    let sectionVal: string = ''
                    const pageLink = button.getAttribute('href')
                    const curentLink = this.get_page_link()
                    const ctaNameFindPage = pageLink ? this.find_cta_name('page', 'header', pageLink) : null
                    const pageTypeFindPage = curentLink ? this.find_page_type('page', curentLink, false) : null
                    const ctaNameFindUrlExterne = pageLink ? this.find_cta_name('urlExterne', 'header', pageLink) : null
                    const findSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.site_section, 'header')
                        : null

                    if (curentLink?.indexOf('/categorie/') !== -1) {
                        const catSlugPageType = this.getLastPart(curentLink)
                        const categoryPageType = catSlugPageType?.replaceAll('-', ' ')

                        if (categoryPageType) {
                            pageTypeFindTerme = this.find_page_type('terme', false, categoryPageType)
                        }
                    }

                    if (pageLink?.indexOf('/categorie/') !== -1) {
                        const catSlug = this.getLastPart(pageLink)
                        const category = catSlug?.replaceAll('-', ' ')

                        if (category) {
                            ctaNameFindTerme = this.find_cta_name('terme', 'header', category)
                        }
                    }

                    if (ctaNameFindPage) {
                        ctaName = ctaNameFindPage
                    } else if (ctaNameFindTerme) {
                        ctaName = ctaNameFindTerme
                    } else if (ctaNameFindUrlExterne) {
                        ctaName = ctaNameFindUrlExterne
                    }

                    if (pageTypeFindPage) {
                        pageType = pageTypeFindPage
                    } else if (pageTypeFindTerme) {
                        pageType = pageTypeFindTerme
                    }

                    if (findSection) {
                        sectionVal = findSection
                    }

                    if (button.querySelector('.brand-logo')) {
                        const findLogo = this.find_cta_name('logo', 'header', false)

                        if (findLogo) {
                            ctaName = findLogo
                        }
                    }

                    window.dataLayer.push({
                        event: 'click.navigation',
                        click: ctaName,
                        click_chapter1: pageType,
                        click_chapter2: sectionVal
                    })
                })
            })
    }

    footer_click() {
        document
            .querySelector('footer')
            ?.querySelector('.footer')
            ?.querySelectorAll('a')
            .forEach(button => {
                button.addEventListener('click', () => {
                    let pageType: string = ''
                    let ctaName: string = ''
                    let ctaNameFindTerme: string | null = null
                    let pageTypeFindTerme: string | null = null
                    let sectionVal: string = ''
                    const pageLink = button.getAttribute('href')
                    const curentLink = this.get_page_link()
                    const ctaNameFindPage = pageLink ? this.find_cta_name('page', 'footer', pageLink) : null
                    const pageTypeFindPage = curentLink ? this.find_page_type('page', curentLink, false) : null
                    const ctaNameFindUrlExterne = pageLink ? this.find_cta_name('urlExterne', 'footer', pageLink) : null
                    const findSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.site_section, 'footer')
                        : null

                    if (curentLink?.indexOf('/categorie/') !== -1) {
                        const catSlugPageType = this.getLastPart(curentLink)
                        const categoryPageType = catSlugPageType?.replaceAll('-', ' ')

                        if (categoryPageType) {
                            pageTypeFindTerme = this.find_page_type('terme', false, categoryPageType)
                        }
                    }

                    if (pageLink?.indexOf('/categorie/') !== -1) {
                        const catSlug = this.getLastPart(pageLink)
                        const category = catSlug?.replaceAll('-', ' ')

                        if (category) {
                            ctaNameFindTerme = this.find_cta_name('terme', 'footer', category)
                        }
                    }

                    if (ctaNameFindPage) {
                        ctaName = ctaNameFindPage
                    } else if (ctaNameFindTerme) {
                        ctaName = ctaNameFindTerme
                    } else if (ctaNameFindUrlExterne) {
                        ctaName = ctaNameFindUrlExterne
                    }

                    if (pageTypeFindPage) {
                        pageType = pageTypeFindPage
                    } else if (pageTypeFindTerme) {
                        pageType = pageTypeFindTerme
                    }

                    if (findSection) {
                        sectionVal = findSection
                    }

                    window.dataLayer.push({
                        event: 'click.navigation',
                        click: ctaName,
                        click_chapter1: pageType,
                        click_chapter2: sectionVal
                    })
                })
            })
    }

    cta_click_accueil() {
        this.home_carousel_click()
        this.vos_avantage_maratp_click()
        this.jeux_concours()
        this.aller_plus_loin()
        this.contenu_exclusif()
        this.related_post()
        this.banniere()
    }

    home_carousel_click() {
        document
            .querySelector('.heading-homepage-slider')
            ?.querySelectorAll('swiper-slide a')
            .forEach(button => {
                button.addEventListener('click', () => {
                    const pageLink = button.getAttribute('href')
                    const curentLink = this.get_page_link()
                    let tagName = button?.querySelector('.post-tag')?.querySelector('span')?.textContent
                    tagName = tagName?.replaceAll('œ', 'oe')
                    tagName = tagName?.toLowerCase()
                    let sectionVal: string = ''
                    let pageType: string = ''
                    let ctaName: string = ''
                    let pageTypeFindTerme: string | null = null
                    const artName = button.querySelector('.post-card-title')?.textContent
                    const cat = button.querySelector('.post-tags span')?.textContent
                    const ctaNameFindPage = pageLink ? this.find_cta_name('page', 'carousel', pageLink) : null
                    const pageTypeFindPage = curentLink ? this.find_page_type('page', curentLink, false) : null
                    const findSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.site_section, 'carousel')
                        : null
                    const findCtaNameSection = this.find_cta_name('article', 'carousel', false)

                    if (findSection) {
                        sectionVal = findSection
                    }

                    if (tagName) {
                        pageTypeFindTerme = this.find_page_type('terme', false, tagName)
                    }

                    if (ctaNameFindPage) {
                        ctaName = ctaNameFindPage
                    } else if (findCtaNameSection) {
                        ctaName = findCtaNameSection
                    }

                    if (pageTypeFindPage) {
                        pageType = pageTypeFindPage
                    } else if (pageTypeFindTerme) {
                        pageType = pageTypeFindTerme
                    }

                    window.dataLayer.push({
                        event: 'click.action',
                        click: ctaName,
                        click_chapter1: pageType,
                        click_chapter2: sectionVal,
                        click_chapter3: artName,
                        click_chapter4: cat
                    })
                })
            })
    }

    vos_avantage_maratp_click() {
        document
            .querySelector('.wp-block-avantages')
            ?.querySelectorAll('a')
            ?.forEach(button => {
                button.addEventListener('click', () => {
                    let sectionVal: string = ''
                    let ctaName: string = ''
                    let pageType: string = ''
                    const curentLink = this.get_page_link()
                    const findSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.site_section, 'avantages')
                        : null
                    const findCtaNameSection = this.find_cta_name('page', 'avantages', curentLink)
                    const pageTypeFindPage = curentLink ? this.find_page_type('page', curentLink, false) : null

                    if (findSection) {
                        sectionVal = findSection
                    }

                    if (findCtaNameSection) {
                        ctaName = findCtaNameSection
                    }

                    if (pageTypeFindPage) {
                        pageType = pageTypeFindPage
                    }

                    window.dataLayer.push({
                        event: 'click.action',
                        click: ctaName,
                        click_chapter1: pageType,
                        click_chapter2: sectionVal,
                        click_chapter3: ''
                    })
                })
            })
    }
    /**
     * To do
     */
    jeux_concours() {
        document
            ?.querySelector('.single-header-meta')
            ?.querySelector('.post-meta')
            ?.querySelectorAll('a')
            ?.forEach(button => {
                button.addEventListener('click', () => {
                    let sectionVal: string = ''
                    let ctaName: string = ''
                    let pageType: string = ''
                    let pageTypeFindTerme: string | null = null
                    const curentLink = this.get_page_link()
                    const findSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.site_section, 'ancreFicheConcours')
                        : null
                    const findCtaNameSection = this.marquerLayers
                        ? this.find_cta_name('ancreFicheConcours', '', false)
                        : null
                    const pageTypeFindPage = curentLink ? this.find_page_type('page', curentLink, false) : null

                    if (this.get_post_category()) {
                        const category = this.get_post_category()

                        pageTypeFindTerme = this.find_page_type('terme', false, category)
                    }

                    if (findSection) {
                        sectionVal = findSection
                    }

                    if (findCtaNameSection) {
                        ctaName = findCtaNameSection
                    }

                    if (pageTypeFindTerme) {
                        pageType = pageTypeFindTerme
                    } else if (pageTypeFindPage) {
                        pageType = pageTypeFindPage
                    }

                    window.dataLayer.push({
                        event: 'click.action',
                        click: ctaName,
                        click_chapter1: pageType,
                        click_chapter2: sectionVal,
                        click_chapter3: ''
                    })
                })
            })

        document
            .querySelector('.concours-section-heading')
            ?.querySelector('.concours-section-cta')
            ?.querySelectorAll('a')
            ?.forEach(button => {
                button.addEventListener('click', () => {
                    let sectionVal: string = ''
                    let ctaName: string = ''
                    let pageType: string = ''
                    let pageTypeFindTerme: string | null = null
                    const pageLink = button.getAttribute('href')
                    const curentLink = this.get_page_link()
                    const findSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.site_section, 'jeuxConcours')
                        : null
                    const findCtaNameSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.cta_name, 'jeuxConcours')
                        : null
                    const pageTypeFindPage = curentLink ? this.find_page_type('page', curentLink, false) : null

                    if (pageLink?.indexOf('/categorie/') !== -1) {
                        const catSlug = this.getLastPart(pageLink)
                        const category = catSlug?.replaceAll('-', ' ')

                        if (category) {
                            pageTypeFindTerme = this.find_page_type('terme', false, category)
                        }
                    }

                    if (findSection) {
                        sectionVal = findSection
                    }

                    if (findCtaNameSection) {
                        ctaName = findCtaNameSection
                    }

                    if (pageTypeFindPage) {
                        pageType = pageTypeFindPage
                    } else if (pageTypeFindTerme) {
                        pageType = pageTypeFindTerme
                    }

                    window.dataLayer.push({
                        event: 'click.action',
                        click: ctaName,
                        click_chapter1: pageType,
                        click_chapter2: sectionVal,
                        click_chapter3: '',
                        click_chapter4: pageType
                    })
                })
            })

        document
            ?.querySelector('.concours-section-content')
            ?.querySelectorAll('a')
            ?.forEach(button => {
                button.addEventListener('click', () => {
                    let sectionVal: string = ''
                    let ctaName: string = ''
                    let pageType: string = ''
                    let category: string = ''
                    let pageTypeFindTerme: string | null = null
                    const postTitle = button.querySelector('.post-card-title')?.textContent
                    const curentLink = this.get_page_link()
                    const findSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.site_section, 'jeuxConcours')
                        : null
                    const findCtaNameSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.cta_name, 'jeuxConcours')
                        : null
                    const pageTypeFindPage = curentLink ? this.find_page_type('page', curentLink, false) : null

                    pageTypeFindTerme = this.find_page_type('terme', false, 'jeux concours')

                    if (findSection) {
                        sectionVal = findSection
                    }

                    if (findCtaNameSection) {
                        ctaName = findCtaNameSection
                    }

                    if (pageTypeFindPage) {
                        pageType = pageTypeFindPage
                    }

                    if (pageTypeFindTerme) {
                        category = pageTypeFindTerme
                    }

                    window.dataLayer.push({
                        event: 'click.action',
                        click: ctaName,
                        click_chapter1: pageType,
                        click_chapter2: sectionVal,
                        click_chapter3: postTitle?.trim(),
                        click_chapter4: category
                    })
                })
            })
    }

    aller_plus_loin() {
        document
            ?.querySelector('.prefooter')
            ?.querySelectorAll('.prefooter-item a')
            ?.forEach(button => {
                button.addEventListener('click', () => {
                    let sectionVal: string = ''
                    let ctaName: string | null | undefined = ''
                    let pageType: string = ''
                    let pageTypeFindTerme: string | null = null
                    const clickedLink = button.getAttribute('href')
                    const pageLink = this.get_page_link()
                    const findSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.site_section, 'allerPlusLoin')
                        : null
                    const pageTypeFindPage = pageLink ? this.find_page_type('page', pageLink, false) : null

                    let findCtaName = clickedLink
                        ? this.find_cta_name('urlExterne', 'allerPlusLoin', clickedLink)
                        : null

                    if (pageLink?.indexOf('/categorie/') !== -1) {
                        const catSlug = this.getLastPart(pageLink)
                        const category = catSlug?.replaceAll('-', ' ')

                        if (category) {
                            pageTypeFindTerme = this.find_page_type('terme', false, category)
                        }
                    }

                    if (clickedLink?.indexOf('/categorie/') !== -1) {
                        const catSlugCta = this.getLastPart(clickedLink)
                        const categoryCta = catSlugCta?.replaceAll('-', ' ')

                        if (categoryCta) {
                            findCtaName = clickedLink ? this.find_cta_name('terme', 'allerPlusLoin', categoryCta) : null
                        }
                    }

                    if (findSection) {
                        sectionVal = findSection
                    }

                    if (pageTypeFindPage) {
                        pageType = pageTypeFindPage
                    } else if (pageTypeFindTerme) {
                        pageType = pageTypeFindTerme
                    }

                    if (findSection) {
                        sectionVal = findSection
                    }

                    if (findCtaName) {
                        ctaName = findCtaName
                    }

                    window.dataLayer.push({
                        event: 'click.action',
                        click: ctaName,
                        click_chapter1: pageType,
                        click_chapter2: sectionVal,
                        click_chapter3: ''
                    })
                })
            })
    }

    click_newsletter() {
        const singleLink = document
            .querySelector('.newsletter-section-content')
            ?.querySelector('.newsletter-section-cta a')

        singleLink?.addEventListener('click', () => {
            let sectionVal: string = ''
            let ctaName: string = ''
            let pageType: string = ''
            let pageTypeFindTerme: string | null = null
            const curentLink = this.get_page_link()
            const findSection = this.marquerLayers
                ? this.find_section(this.marquerLayers.site_section, 'newsletter')
                : null
            const findCtaNameSection = this.marquerLayers
                ? this.find_section(this.marquerLayers.cta_name, 'newsletter')
                : null
            const pageTypeFindPage = curentLink ? this.find_page_type('page', curentLink, false) : null
            if (this.get_post_category()) {
                const category = this.get_post_category()

                pageTypeFindTerme = this.find_page_type('terme', false, category)
            }
            if (findSection) {
                sectionVal = findSection
            }

            if (findCtaNameSection) {
                ctaName = findCtaNameSection
            }

            if (pageTypeFindPage) {
                pageType = pageTypeFindPage
            }

            if (pageTypeFindTerme) {
                pageType = pageTypeFindTerme
            }

            window.dataLayer.push({
                event: 'click.action',
                click: ctaName,
                click_chapter1: pageType,
                click_chapter2: sectionVal,
                click_chapter3: ''
            })
        })
    }

    post_listing() {
        document
            .querySelector('.post-listing-wrapper')
            ?.querySelectorAll('a.post-card')
            .forEach(button => {
                button.addEventListener('click', () => {
                    let sectionVal: string = ''
                    let ctaName: string = ''
                    let pageType: string = ''
                    let pageTypeFindTerme: string | null = null
                    const curentLink = this.get_page_link()
                    const cat = this.get_post_category()
                    const artName = button.querySelector('.post-card-title')?.textContent
                    const findSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.site_section, 'pageListCategory')
                        : null
                    const findCtaName = this.find_cta_name('article', 'pageListCategory', false)

                    const pageTypeFindPage = curentLink ? this.find_page_type('page', curentLink, false) : null

                    if (this.get_post_category()) {
                        const category = this.get_post_category()

                        pageTypeFindTerme = this.find_page_type('terme', false, category)
                    }

                    if (findSection) {
                        sectionVal = findSection
                    }

                    if (pageTypeFindPage) {
                        pageType = pageTypeFindPage
                    } else if (pageTypeFindTerme) {
                        pageType = pageTypeFindTerme
                    }

                    if (findCtaName) {
                        ctaName = findCtaName
                    }

                    window.dataLayer.push({
                        event: 'click.action',
                        click: ctaName,
                        click_chapter1: pageType,
                        click_chapter2: sectionVal,
                        click_chapter3: artName,
                        click_chapter4: cat
                    })
                })
            })
    }

    related_post() {
        document
            .querySelector('.related-posts')
            ?.querySelector('.related-posts-items')
            ?.querySelectorAll('a')
            .forEach(button => {
                button.addEventListener('click', () => {
                    let sectionVal: string = ''
                    let ctaName: string = ''
                    const artName = button.querySelector('.post-card-title')?.textContent
                    const cat = button.querySelector('.post-tags span')?.textContent
                    const findSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.site_section, 'articleSimilaire')
                        : null
                    const findCtaName = this.marquerLayers
                        ? this.find_section(this.marquerLayers.cta_name, 'articleSimilaire')
                        : null

                    if (findSection) {
                        sectionVal = findSection
                    }

                    if (findCtaName) {
                        ctaName = findCtaName
                    }

                    window.dataLayer.push({
                        event: 'click.action',
                        click: ctaName,
                        click_chapter1: '',
                        click_chapter2: sectionVal,
                        click_chapter3: artName,
                        click_chapter4: cat
                    })
                })
            })
    }

    social_share() {
        document
            ?.querySelector('.share-social')
            ?.querySelectorAll('a')
            ?.forEach(button => {
                button.addEventListener('click', () => {
                    const ctaName = button?.getAttribute('aria-label')
                    const postCat = window.layerData.post_category
                    const socialMedia = ctaName?.replace('Partager sur ', '')

                    window.dataLayer.push({
                        event: 'click.action',
                        click: 'partager sur un reseau social',
                        click_chapter1: postCat,
                        click_chapter2: socialMedia,
                        click_chapter3: this.getTitle()
                    })
                })
            })
    }

    contenu_exclusif() {
        document
            .querySelector('.exclusif-content-items')
            ?.querySelectorAll('a')
            .forEach(button => {
                button.addEventListener('click', () => {
                    const cat = button.querySelector('.post-tags span')?.textContent
                    let sectionVal: string = ''
                    let ctaName: string = ''
                    let pageType: string = ''
                    let pageTypeFindTerme: string | null = null
                    let tagName = button?.querySelector('.post-tag')?.querySelector('span')?.textContent
                    const curentLink = this.get_page_link()
                    tagName = tagName?.replaceAll('œ', 'oe')
                    tagName = tagName?.toLowerCase()
                    const ctaTitle = button?.querySelector('.post-card-title')?.textContent
                    const findSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.site_section, 'contenuExclusif')
                        : null
                    const findCtaName = this.marquerLayers
                        ? this.find_section(this.marquerLayers.cta_name, 'contenuExclusif')
                        : null
                    const pageTypeFindPage = curentLink ? this.find_page_type('page', curentLink, false) : null

                    if (findSection) {
                        sectionVal = findSection
                    }

                    if (findCtaName) {
                        ctaName = findCtaName
                    }

                    if (tagName) {
                        pageTypeFindTerme = this.find_page_type('terme', false, tagName)
                    }

                    if (pageTypeFindPage) {
                        pageType = pageTypeFindPage
                    } else if (pageTypeFindTerme) {
                        pageType = pageTypeFindTerme
                    }

                    window.dataLayer.push({
                        event: 'click.action',
                        click: ctaName,
                        click_chapter1: pageType,
                        click_chapter2: sectionVal,
                        click_chapter3: ctaTitle,
                        click_chapter4: cat
                    })
                })
            })
    }

    banniere() {
        document
            .querySelector('.banner-message')
            ?.querySelectorAll('a')
            .forEach(button => {
                button.addEventListener('click', () => {
                    let ctaName: string = ''
                    let sectionVal: string = ''
                    const findCtaName = this.marquerLayers ? this.find_cta_name('banniere', 'header', false) : null
                    const findSection = this.marquerLayers
                        ? this.find_section(this.marquerLayers.site_section, 'header')
                        : null

                    if (findCtaName) {
                        ctaName = findCtaName
                    }

                    if (findSection) {
                        sectionVal = findSection
                    }

                    window.dataLayer.push({
                        event: 'click.action',
                        click: ctaName,
                        click_chapter1: sectionVal,
                        click_chapter2: ''
                    })
                })
            })
    }

    consent_checkbox() {
        setTimeout(function () {
            const consent = document.getElementById('consent_piano') as HTMLInputElement
            if (consent && window.pa && window.tcCategoriesConsent) {
                const mode = window.pa.consent.getMode()
                consent.checked = mode === 'opt-in' || mode === 'essential'
                consent.addEventListener('change', (): void => {
                    if (consent.checked && window.tcCategoriesConsent.indexOf('4') !== -1) {
                        window.pa.consent.setMode('opt-in')
                    } else if (consent.checked && window.tcCategoriesConsent.indexOf('4') === -1) {
                        window.pa.consent.setMode('essential')
                    } else {
                        window.pa.consent.setMode('opt-out')
                    }
                })
            }
        }, 2000)
    }
}
